var _style, _circle, _path, _path2, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 128 128",
    style: {
      enableBackground: "new 0 0 128 128"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#F7F8DE;stroke-width:4;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#F7F8DE;stroke-width:5.75;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#F7F8DE;stroke-width:11;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st3{fill:#F7F8DE;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 64.35,
    cy: 63.84,
    r: 61.35
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65.38,21.49"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M43.38,43.33c-0.34-6.76,4.45-12.68,9.83-16.21c10.7-7,26.9-3.63,32.59,8.33c2.54,5.33,1.02,12.04-2.29,16.69 c-2.42,3.39-5.83,5.36-9.13,7.73c-3.03,2.18-5.77,4.75-8.12,7.64c-3.27,4.01-3.19,10.18-2.25,15"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 64,
    cy: 98.55,
    r: 4.67
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.15029c3cc210ad161c4850eac625b1c4.svg";
export { ForwardRef as ReactComponent };